export default __webpack_public_path__ + "static/media/offshore.8751378f.svg";